<template>
  <v-chip
      :color="getConfirmColor"
      :class="getConfirmClass"
      label>
    {{ isConfirm ? textYes : textNo }}
  </v-chip>

</template>

<script>
export default {
  name: "ConfirmChip",
  props: {
    isConfirm: {
      type: Boolean,
      default: true
    },
    greenRed: {
      type: Boolean,
      default: false
    },
    textYes: {
      type: String,
      required: true
    },
    textNo: {
      type: String,
      required: true
    },
  },
  computed: {
    getConfirmClass() {
      return this.isConfirm ? "confirm-chip" : this.greenRed ? "not-confirm-chip-red" : "not-confirm-chip"
    },
    getConfirmColor() {
      return this.isConfirm ? "#F6FFED" : this.greenRed ? "#FFF1F0" : '#FAFAFA'
    },
  },
}
</script>

<style scoped>

.confirm-chip {
  color: #52C41A;
  border: 1px solid #B7EB8F !important;;
}

.not-confirm-chip-red {
  color: #F5222D;
  border: 1px solid #FFA39E !important;
}

.not-confirm-chip {
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #D9D9D9 !important;
}


</style>